import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LocationSearchData } from '../types';
import { RootState } from '.';

type LocationType = LocationSearchData | any;

const initialState: LocationType = {};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocation: (_state: LocationType, action: PayloadAction<LocationType>) => {
      return { location: action.payload };
    },
  },
});

export const selectLocation = (state: RootState) => state.location;

export const { setLocation } = locationSlice.actions;

export default locationSlice.reducer;
